export class CalculatorService {

	private static instance: CalculatorService;

	constructor() { }

	static getInstance() {
		if (!CalculatorService.instance) {
			CalculatorService.instance = new CalculatorService();
		}
		return CalculatorService.instance;
	}

	// DETECT CALCULATOR
	detect(form: HTMLFormElement) {
		switch (form.id) {

			case 'calculator-how_much_can_i_borrow':
				this.doHL1(form);
				break;

			case 'calculator-how_much_will_i_pay_monthly':
				this.doHL2(form);
				break;

			case 'calculator-how_can_i_reduce_my_bond':
				this.doHL3(form);
				break;

			case 'calculator-personal_loans':
				this.doPL(form);
				break;

			case 'calculator-vaf_how_much_can_i_afford':
				this.doVAF1(form);
				break;

			case 'calculator-vaf_monthly_repayments':
				this.doVAF2(form);
				break;

			case 'calculator-vaf_finance_calculator':
				this.doVAF3(form);
				break;
				
			default:
				break;

		}
	}
	// CALCULATOR
	doHL1(form: HTMLFormElement) {
		let total: number = 0;
		const gross: any = form.querySelectorAll('input[name=gross_monthly_income]');
		const expenses: any = form.querySelector('input[name=monthly_expenses]');
		let interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_borrow: any = document.querySelectorAll('span.js-calculator-borrow-up-to-hl1');
		const estimate_repayment: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl1');
		[].slice.call(gross).forEach(function (input) {
			if (input.value) {
				total += parseFloat(input.value);
			}
		});
		const answer = this.HLHowMuchCanIBorrow(total, 0, expenses.value, term.value, interest.value);
		[].slice.call(output_borrow).forEach(function (div) {
			div.innerHTML = answer.loanAmounts;
		});
		[].slice.call(estimate_repayment).forEach(function (div) {
			div.innerHTML = answer.monthlyPayments;
		});
	}
	doHL2(form: HTMLFormElement) {
		const purchaseprice: any = form.querySelector('input[name=purchase_price]');
		const deposit: any = form.querySelector('input[name=include_deposit]');
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_estimate: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl2');
		const output_period: any = document.querySelectorAll('span.js-calculator-loan-period-hl2');
		const answer = this.HLWhatWillIPayPerMonth(purchaseprice.value, deposit.value, term.value, interest.value);
		[].slice.call(output_estimate).forEach(function (div) {
			div.innerHTML = answer.monthlyRepayments;
		});
		[].slice.call(output_period).forEach(function (div) {
			div.innerHTML = answer.loanTerm;
		});
	}
	doHL3(form: HTMLFormElement) {

		const bondbalance: any = form.querySelector('input[name=current_bond_balance]');
		const loanterm: any = form.querySelector('input[name=remaining_loan_term]');
		const interest: any = form.querySelector('input[name=variable_interest_rate]');

		const additional: any = form.querySelector('input[name=additional_recurring_payment]');
		const lumpsum: any = form.querySelector('input[name=once_off_lump_sum]');
		const reduceterm: any = form.querySelector('input[name=term_reduce]');

		const output_current_repayment: any = document.querySelectorAll('span.js-calculator-current-repayment-hl3');
		const output_estimated_repayment: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl3');
		const output_new_loanterm: any = document.querySelectorAll('span.js-calculator-new-loan-term-hl3');
		const output_interest_savings: any = document.querySelectorAll('span.js-calculator-interest-savings-hl3');

		const answer = this.HLHowCanIReduceMyBond(
			bondbalance.value,
			loanterm.value,
			interest.value,
			additional.value,
			lumpsum.value,
			reduceterm.value
		);

		[].slice.call(output_current_repayment).forEach(function (div) {
			div.innerHTML = answer.currentRepayment;
		});
		[].slice.call(output_estimated_repayment).forEach(function (div) {
			div.innerHTML = answer.estimatedRepayment;
		});
		[].slice.call(output_new_loanterm).forEach(function (div) {
			div.innerHTML = answer.newLoanTerm;
		});
		[].slice.call(output_interest_savings).forEach(function (div) {
			div.innerHTML = answer.interestSavings;
		});

	}
	doPL(form: HTMLFormElement) {
		let total: number = 0;
		const loanamount: any = form.querySelector('input[name=loan_amount]');
		total = parseFloat(loanamount.value)
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const term: any = form.querySelector('input[name=term]');
		const output_borrow: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
		const output_months: any = document.querySelectorAll('span.js-calculator-loan-period-pl1');
		const output_date: any = document.querySelectorAll('span.js-calculator-first-repayment-date-pl1');
		const output_fees: any = document.querySelectorAll('span.js-calculator-total-interest-pl1');

		const answer = this.PLMonthlyRepayments(total, interest.value, term.value);
		[].slice.call(output_borrow).forEach(function (div) {
			div.innerHTML = answer.estimatedMonthlyRepayment;
		});
		[].slice.call(output_date).forEach(function (div) {
			div.innerHTML = answer.date;
		});
		[].slice.call(output_fees).forEach(function (div) {
			div.innerHTML = answer.totalInterest;
		});
	}
	doVAF1(form: HTMLFormElement) {
		let total: number = 0;
		const gross: any = form.querySelectorAll('input[name=gross_monthly_income]');
		const expenses: any = form.querySelector('input[name=monthly_expenses]');
		const output_available: any = document.querySelectorAll('span.js-calculator-available');
		[].slice.call(gross).forEach(function (input) {
			if (input.value) {
				total += parseFloat(input.value);
			}
		});
		const answer = this.VAFHowMuchCanIAfford(total, expenses.value);
		[].slice.call(output_available).forEach(function (div) {
			div.innerHTML = answer.availablePerMonth;
		});
	}
	doVAF2(form: HTMLFormElement) {
		const purchaseprice: any = form.querySelector('input[name=purchase_price]');
		const deposit: any = form.querySelector('input[name=deposit]');
		const term: any = form.querySelector('select[name=term]');
		const balloon: any = form.querySelector('input[name=balloon]');
		const interest: any = form.querySelector('input[name=variable_interest_rate]');
		const output_loan: any = document.querySelectorAll('span.js-calculator-total-paid-vaf2');
		const output_estimate: any = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf2');
		const answer = this.VAFMonthlyRepayments(purchaseprice.value, deposit.value, balloon.value, 0, term.value, interest.value);
		[].slice.call(output_loan).forEach(function (div) {
			div.innerHTML = answer.loanAmount;
		});
		[].slice.call(output_estimate).forEach(function (div) {
			div.innerHTML = answer.monthlyRepayment;
		});
	}
	doVAF3(form: HTMLFormElement) {
		const preferredrepayment: any = form.querySelector('input[name=preferred_monthly_repayment]');
		const deposit: any = form.querySelector('input[name=deposit_2]');
		const term: any = form.querySelector('select[name=term_2]');
		const interest: any = form.querySelector('input[name=variable_interest_rate_2]');
		const output_amount: any = document.querySelectorAll('span.js-calculator-amount-i-can-spend-vaf3');
		const answer = this.VAFVehiclePurchasePrice(preferredrepayment.value, deposit.value, term.value, interest.value);
		[].slice.call(output_amount).forEach(function (div) {
			div.innerHTML = answer.amount;
		});
	}

	// PERSONAL LOANS
	PLMonthlyRepayments(
		loanamount: number = 0,
		loaninterest: number = 0,
		loanterm: number = 10.25
	) {
		const initiationFee: number = Math.min(1050, 165 + 0.1 * (loanamount - 1000)) * 1.15;
		const serviceFee: number = 60 * 1.15;

		let normalValue: number = loanamount / loanterm;
		normalValue = this.round(normalValue, 2);

		let final: number = -this.pmt_vaf(loaninterest / 1200, loanterm, (loanamount + initiationFee), 0, 0) + serviceFee;
		final = this.round(final, 2);

		let interestTotal: number = this.round((final - normalValue), 2);

		let todaysDate: any = new Date();
		let getMonth: number = todaysDate.getMonth();
		todaysDate.setMonth(getMonth + 1, 1);
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

		return {
			date: "1 " + monthNames[todaysDate.getMonth()] + " " + todaysDate.getFullYear(),
			iFee: initiationFee,
			sFee: serviceFee,
			totalInterest: this.formatter(interestTotal),
			estimatedMonthlyRepayment: this.formatter(final)
		};
	}

	// HOMELOANS
	HLHowMuchCanIBorrow(
		gross: any = 0,
		additional: any = 0,
		expenses: any = 0,
		term: any = 0,
		interest: any = 10.25,
		rir: any = 0.30
	) {
		/* monthly payments */
		const amount: number = parseFloat(gross) + parseFloat(additional);
		const net: number = amount - parseFloat(expenses);
		const monthlyPaymentC = Math.min(net, (amount * rir));
		const monthlyPayment = this.formatter(monthlyPaymentC);
		/* loan amount */
		const interestRate = interest / 1200;
		const months = term * 12;
		const loanAmount = this.formatter(monthlyPaymentC * (1 - Math.pow(1 + interestRate, -months)) / interestRate);

		return {
			monthlyPayments: monthlyPayment,
			loanAmounts: loanAmount
		};
	}
	HLWhatWillIPayPerMonth(
		purchase: any = 0,
		deposit: any = 0,
		term: any = 0,
		interest: any = 10.25
	) {
		const terms: any = term * 12;
		const inputPurchase: number = parseFloat(purchase);
		const inputDeposit: number = parseFloat(deposit);
		const inputInterest: number = parseFloat(interest);
		const inputTerm: number = parseFloat(terms);
		const monthlyRepayment: string = this.formatter(
			-this.round(
				this.pmt(inputInterest, 12, inputTerm, (inputPurchase - inputDeposit), 0),
				0)
		);
		return {
			monthlyRepayments: monthlyRepayment,
			loanTerm: terms + ' months'
		};
	}
	HLHowCanIReduceMyBond(
		balance: any = 0,
		remainingterm: any = 0,
		interest: any = 10.25,
		paymoreAdditonal: any = 0,
		paymoreLumpsum: any = 0,
		reduceTerm: any = 0
	) {
		let currentPMT: number = 0;
		let currentPMTFormatted: any = 0;
		let estimatedPMTFormatted: any = 0;
		let newLoanTermFormatted: number = 0;
		let interestSavingsFormatted: any = 0;
		let lumpSumNewRepayment: any = 0;
		let lumpSumNewInterestSavings: any = 0;
		let nper: number = 0;

		// only additional added
		if (paymoreAdditonal > 0 && paymoreLumpsum == 0) {
			const valueWithoutAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
			const valueWithAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0) + parseFloat(paymoreAdditonal);
			nper = this.nper(interest, 12, valueWithAdditional, -(balance - paymoreLumpsum), 0);
			newLoanTermFormatted = Math.ceil(nper / 12);
			const valueSavingsAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
			const valueSavingsAdditional2 = this.cumipmt(balance, interest, nper, valueWithAdditional);
			const valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
			interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);
			currentPMTFormatted = this.formatter(valueWithoutAdditional);
			estimatedPMTFormatted = this.formatter(valueWithAdditional);

		} else if (paymoreAdditonal > 0 && paymoreLumpsum > 0) {
			const valueWithoutAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
			const valueWithAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0) + parseFloat(paymoreAdditonal);
			nper = this.nper(interest, 12, valueWithAdditional, -(balance - paymoreLumpsum), 0);
			newLoanTermFormatted = Math.ceil(nper / 12);
			const valueSavingsAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
			const valueSavingsAdditional2 = this.cumipmt(balance - paymoreLumpsum, interest, nper, valueWithAdditional);
			const valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
			interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);
			currentPMTFormatted = this.formatter(valueWithoutAdditional);
			estimatedPMTFormatted = this.formatter(valueWithAdditional);

		} else if (paymoreAdditonal == 0 && paymoreLumpsum > 0) {
			const totalAmount: number = balance - paymoreLumpsum;
			const valueWithAdditional: number = -this.pmt(interest, 12, remainingterm * 12, totalAmount, 0);
			const valueWithoutAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
			nper = this.nper(interest, 12, valueWithoutAdditional, -totalAmount, 0);
			newLoanTermFormatted = Math.ceil(nper / 12);
			const valueSavingsOrigAdditional1 = this.cumipmt(balance, interest, remainingterm * 12, valueWithoutAdditional);
			const valueSavingsOrigAdditional2 = this.cumipmt(totalAmount, interest, nper, valueWithoutAdditional);
			const valueSavingsOrigAdditionalFinal = this.round(valueSavingsOrigAdditional1 - valueSavingsOrigAdditional2, 0);
			const valueSavingsAdditional1 = this.cumipmt2(interest / 1200, remainingterm, balance, 1, remainingterm, 0);
			const valueSavingsAdditional2 = this.cumipmt2(interest / 1200, remainingterm, totalAmount, 1, remainingterm, 0);
			const valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 0);
			interestSavingsFormatted = this.formatter(valueSavingsOrigAdditionalFinal);
			currentPMTFormatted = this.formatter(valueWithoutAdditional);
			estimatedPMTFormatted = this.formatter(valueWithAdditional);
			lumpSumNewRepayment = this.formatter(valueWithAdditional);
			lumpSumNewInterestSavings = this.formatter(valueSavingsAdditionalFinal);

		} else if (paymoreAdditonal == 0 && paymoreLumpsum == 0 && reduceTerm > 0) {
			const valueWithoutAdditional: number = -this.pmt(interest, 12, remainingterm * 12, balance, 0);
			const valueWithAdditional: number = -this.pmt(interest, 12, reduceTerm * 12, balance, 0);
			const valueSavingsAdditional1 = this.cumipmt2(interest / 1200, remainingterm * 12, balance, 1, remainingterm * 12, 0);
			const valueSavingsAdditional2 = this.cumipmt2(interest / 1200, reduceTerm * 12, balance, 1, reduceTerm * 12, 0);
			const valueSavingsAdditionalFinal = this.round(valueSavingsAdditional1 - valueSavingsAdditional2, 2);
			estimatedPMTFormatted = this.formatter(valueWithAdditional);
			newLoanTermFormatted = Math.ceil(reduceTerm * 12 / 12);
			currentPMTFormatted = this.formatter(valueWithoutAdditional);
			interestSavingsFormatted = this.formatter(valueSavingsAdditionalFinal);

		} else {
			currentPMT = Number(this.round(-this.pmt(interest, 12, remainingterm * 12, balance, 0), 0));
			currentPMTFormatted = this.formatter(currentPMT);
		}

		return {
			currentRepayment: currentPMTFormatted,
			estimatedRepayment: estimatedPMTFormatted,
			newLoanTerm: newLoanTermFormatted,
			interestSavings: interestSavingsFormatted,
			lumpSumNewMonthlyRepayment: lumpSumNewRepayment,
			lumpSumNewInterestSavings: lumpSumNewInterestSavings
		};

	}

	// VEHICLE AND ASSET FINANCE
	VAFHowMuchCanIAfford(gross: number = 0, expenses: number = 0) {
		const amount: number = gross - expenses;
		return {
			availablePerMonth: this.formatter(amount)
		};
	}
	VAFMonthlyRepayments(
		purchaseprice: number = 0,
		deposit: number = 0,
		baloonpercentage: number = 0,
		baloonamount: number = 0,
		loanterm: number = 0,
		interest: number = 10.25
	) {

		if (purchaseprice == 0) {
			return {
				monthlyRepayment: this.formatter(0),
				loanAmount: this.formatter(0)
			};
		}

		let monthlyRepayment: any = 0;
		let loanAmount: any = 0;

		let getLoan: number = 0;
		let getFinalLoan: number = 0;
		let getPayments: number = 0;
		let getDeposit: number = deposit;
		let getBalloonAmt: number = baloonamount;
		let getAmtAdminFee: number = 68.40;

		let i: number = interest;
		i = i / 100.0;
		i /= 12;
		let pow: number = 1;
		let j: number = 0;
		while (j < loanterm) {
			pow = pow * (1 + i);
			j++;
		}

		getLoan = purchaseprice - deposit;

		getBalloonAmt = baloonpercentage * purchaseprice / 100;
		getFinalLoan = (getLoan - getBalloonAmt / pow);
		getPayments = (getFinalLoan * pow * i) / (pow - 1);
		// monthlyRepayment = getPayments + getAmtAdminFee;
		monthlyRepayment = getPayments;
		loanAmount = (getPayments + getAmtAdminFee) * loanterm;
		if (baloonpercentage > 0) {
			loanAmount = getBalloonAmt + loanAmount;
		}
		return {
			monthlyRepayment: this.formatter(monthlyRepayment),
			loanAmount: this.formatter(loanAmount)
		};
	}
	VAFVehiclePurchasePrice(
		preferredpayment: number = 0,
		deposit: number = 0,
		loanterm: number = 0,
		interest: number = 10.25
	) {
		let amount: any = 0;
		let depositString: any = deposit;
		let i: number = interest;
		i = i / 100.0;
		i /= 12;
		let j: number = 0;
		let pow: number = 1;
		while (j < loanterm) {
			pow = pow * (1 + i);
			j++;
		}
		amount = (preferredpayment * (1 - Math.pow(1 + i, -loanterm)) / i) + deposit;
		let amountFinal = parseFloat(amount) + parseFloat(depositString);
		return {
			amount: this.formatter(amountFinal)
		};
	}

	// RESET VALUES	- OUTPUTS
	resetValues(form: HTMLFormElement) {
		switch (form.id) {

			case 'calculator-how_much_can_i_borrow':
				const output_borrow_hl: any = document.querySelectorAll('span.js-calculator-borrow-up-to-hl1');
				const estimate_repayment_hl: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl1');
				[].slice.call(output_borrow_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(estimate_repayment_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			case 'calculator-how_much_will_i_pay_monthly':
				const output_estimate_hl: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl2');
				const output_period_hl: any = document.querySelectorAll('span.js-calculator-loan-period-hl2');
				[].slice.call(output_estimate_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_period_hl).forEach(function (div) {
					div.innerHTML = '0 months';
				});
				break;

			case 'calculator-how_can_i_reduce_my_bond':
				const output_current_repayment_hl: any = document.querySelectorAll('span.js-calculator-current-repayment-hl3');
				const output_estimated_repayment_hl: any = document.querySelectorAll('span.js-calculator-estimated-repayment-hl3');
				const output_new_loanterm_hl: any = document.querySelectorAll('span.js-calculator-new-loan-term-hl3');
				const output_interest_savings_hl: any = document.querySelectorAll('span.js-calculator-interest-savings-hl3');
				[].slice.call(output_current_repayment_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_estimated_repayment_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_new_loanterm_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_interest_savings_hl).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			case 'calculator-personal_loans':
				const output_borrow_pl: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
				const output_months_pl: any = document.querySelectorAll('span.js-calculator-loan-period-pl1');
				[].slice.call(output_borrow_pl).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_months_pl).forEach(function (div) {
					div.innerHTML = '0 months';
				});
				break;

			case 'calculator-personal_loans_test':
				const output_borrow_plt: any = document.querySelectorAll('span.js-calculator-estimated-repayment-pl1');
				const output_months_plt: any = document.querySelectorAll('span.js-calculator-loan-period-pl1');
				[].slice.call(output_borrow_plt).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_months_plt).forEach(function (div) {
					div.innerHTML = '0 months';
				});
				break;

			case 'calculator-vaf_how_much_can_i_afford':
				const output_available_vaf: any = document.querySelectorAll('span.js-calculator-available');
				[].slice.call(output_available_vaf).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			case 'calculator-vaf_monthly_repayments':
				const output_loan_vaf: any = document.querySelectorAll('span.js-calculator-total-paid-vaf2');
				const output_estimate_vaf: any = document.querySelectorAll('span.js-calculator-estimated-repayment-vaf2');
				[].slice.call(output_loan_vaf).forEach(function (div) {
					div.innerHTML = '0';
				});
				[].slice.call(output_estimate_vaf).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			case 'calculator-vaf_finance_calculator':
				const output_amount_vaf: any = document.querySelectorAll('span.js-calculator-amount-i-can-spend-vaf3');
				[].slice.call(output_amount_vaf).forEach(function (div) {
					div.innerHTML = '0';
				});
				break;

			default:
				break;

		}
	}

	// FORMATTERS
	formatter(value) {
		return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
	}
	noalpha(input) {
		input.value = input.value.replace(/[^0-9]/g, '');
	}
	round(expr, decplaces) {
		let decpoint, str;
		str = '' + Math.round(expr * Math.pow(10, decplaces));
		while (str.length <= decplaces) {
			str = '0' + str;
		}
		decpoint = str.length - decplaces;
		return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
	}
	pmt(rate: number = 0, per: number = 0, nper: number = 0, pv: number = 0, fv: number = 0) {
		let pmt_value, x;
		if ((per === 0) || (nper === 0)) {
			return 0;
		}
		rate = rate / (per * 100);
		if (rate === 0) {
			pmt_value = -(fv + pv) / nper;
		} else {
			x = Math.pow(1 + rate, nper);
			pmt_value = -((rate * (fv + x * pv)) / (-1 + x));
		}
		pmt_value = this.round(pmt_value, 2);
		return pmt_value;
	}
	pmt_vaf(rate: number = 0, period: number = 0, value: number = 0, futurevalue: number = 0, type: number = 0) {
		if (!futurevalue) futurevalue = 0;
		if (!type) type = 0;

		if (rate == 0) return -(value + futurevalue) / period;

		var pvif = Math.pow(1 + rate, period);
		var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);

		if (type == 1) {
			pmt /= (1 + rate);
		};

		return pmt;
	}
	nper(rate: number = 0, per: number = 0, pmt: number = 0, pv: number = 0, fv: number = 0) {
		let nper_value: number;
		if ((per === 0) || (pmt === 0)) {
			return 0;
		}
		rate = rate / (per * 100);
		if (rate === 0) {
			nper_value = -(fv + pv) / pmt;
		} else {
			nper_value = Math.log((-fv * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);
		}
		const end: any = this.round(nper_value, 2);
		return parseFloat(end);
	}
	cumipmt(amount: number = 0, rate: number = 0, term: number = 0, pmt: number = 0) {
		let i, insertedAmount, interestSavings, k, ref, totalInterest, value1, value2, value3;
		totalInterest = 0;
		insertedAmount = amount;
		interestSavings = 0;
		for (i = k = 0, ref = term; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
			value1 = insertedAmount * (rate / 1200);
			value2 = pmt - value1;
			value3 = insertedAmount - value2;
			insertedAmount = value3;
			interestSavings = interestSavings + value1;
		}
		return interestSavings;
	}
	cumipmt2(rate: number = 0, periods: number = 0, value: number = 0, start: number = 0, end: number = 0, type: number = 0) {
		let i, interest, payment;
		payment = this.pmt_cumipmt(rate, periods, value, 0, type);
		interest = 0;
		if (start === 1) {
			if (type === 0) {
				interest = -value;
				start++;
			}
		}
		i = start;
		while (i <= end) {
			if (type === 1) {
				interest += this.fv(rate, i - 2, payment, value, 1) - payment;
			} else {
				interest += this.fv(rate, i - 1, payment, value, 0);
			}
			i++;
		}
		interest *= rate;
		return -interest;
	}
	fv(rate: number = 0, periods: number = 0, payment: number = 0, value: number = 0, type: number = 0) {
		let result, term;
		value = value || 0;
		type = type || 0;
		result = void 0;
		if (rate === 0) {
			result = value + payment * periods;
		} else {
			term = Math.pow(1 + rate, periods);
			if (type === 1) {
				result = value * term + payment * (1 + rate) * (term - 1) / rate;
			} else {
				result = value * term + payment * (term - 1) / rate;
			}
		}
		return -result;
	}
	pmt_cumipmt(rate: number = 0, periods: number = 0, present: number = 0, future: number = 0, type: number = 0) {
		let result, term;
		future = future || 0;
		type = type || 0;
		result = void 0;
		if (rate === 0) {
			result = (present + future) / periods;
		} else {
			term = Math.pow(1 + rate, periods);
			if (type === 1) {
				result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
			} else {
				result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
			}
		}
		return -result;
	}

	// SIMPLE INTEREST
	simpleInterest(deposit: number = 0, term: number = 0, interest: number = 10.25) {
		let result = 0;
		let _interest = (interest / 100);
		let _years = (term / 12);

		result = deposit * (1 + (_interest * _years));

		return {
			amount: this.formatter(result),
		}
	}

	// COMPOUND INTEREST
	compoundInterest(deposit: any = 0, monthlyDeposit: any = 0, term: any = 0, interest: any = 10.25) {
		const _deposit: number = parseFloat(deposit);
		const _monthlyDeposit: number = parseFloat(monthlyDeposit);
		const _term: number = parseFloat(term);
		const _interest: number = parseFloat(interest);

		const _intRate = this.round((Math.pow(1 + _interest / 100, 1 / 12) - 1), 3);

		let result: number = 0;

		for (let a = 0; a < _term; a++) {
			let _int: number = 0;

			if (a == 0) {
				_int = (_deposit * _intRate);
				result = _deposit;
			} else {
				_int = ((result * _intRate) + _monthlyDeposit);
			}

			_int = this.round(_int, 2);
			result = this.round((result + _int), 2);
		}
		return {
			amount: this.formatter(result),
		}
	}
}



// WEBPACK FOOTER //
// ./services/calculator.service.ts